import { Drawer } from 'antd'

import { drawerAndModalWidth } from '../../../../../util/guideline'
import { RatingComplianceRule } from '../models'
import { UpdateIssuerCompliance } from './UpdateRatingComplianceRule'

interface UpdateRatingComplianceDrawerProps {
  domain: string
  groupId: number
  ratingComplianceRule: RatingComplianceRule
  isVisible: boolean
  onClose: () => void
  onSuccess: () => void
}

export const UpdateRatingComplianceRuleDrawer = ({
  domain,
  groupId,
  ratingComplianceRule,
  isVisible,
  onClose,
  onSuccess,
}: UpdateRatingComplianceDrawerProps) => {
  return (
    <Drawer
      title="Update Rating Compliance Rule"
      placement="right"
      open={isVisible}
      onClose={onClose}
      width={drawerAndModalWidth}
      destroyOnClose
    >
      <UpdateIssuerCompliance
        domain={domain}
        groupId={groupId}
        ratingComplianceRule={ratingComplianceRule}
        onSuccess={onSuccess}
      />
    </Drawer>
  )
}
